import { GrowthBookContext } from '@growthbook/growthbook-react';
import { ENABLED_DESIGN_SYSTEM_COMPONENTS } from '@openx/constants/feature-flag-keys';
import { useContext } from 'react';

export type DesignSystemComponent =
  | 'autocomplete'
  | 'pageHeader'
  | 'textField'
  | 'switchField'
  | 'toggleButtonGroupField';

// `override` (a component's `designSystem` prop) wins over the feature. Without a GrowthBookProvider (cta, tracex,
// dispatcher, unit tests) the legacy version renders; `useFeatureValue` would throw there, hence the context read.
export const useDesignSystemEnabled = (component: DesignSystemComponent, override?: boolean): boolean => {
  const { growthbook } = useContext(GrowthBookContext);
  const enabledComponents = growthbook?.getFeatureValue<string[]>(ENABLED_DESIGN_SYSTEM_COMPONENTS, []);

  return override ?? (Array.isArray(enabledComponents) && enabledComponents.includes(component));
};
